"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OrderStatus = _interopRequireDefault(require("../../Orders/OrderStatus"));
var _constants = require("../../Orders/OrderStatus/constants");
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _tagsSelect = require("../../../../icons-react/tags-select");
var _excluded = ["value"],
  _excluded2 = ["data"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX,
  StyledRemove = _Selector["default"].StyledRemove,
  StyledMultiValue = _Selector["default"].StyledMultiValue;
var PLACEHOLDER = 'Все статусы заказа';
var StyledTicketFilterByOrderStatus = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TicketFilterByOrderStatus__StyledTicketFilterByOrderStatus",
  componentId: "sc-1uaaiiz-0"
})(["border:1px solid #e6e9ee;box-sizing:border-box;border-radius:4px;padding:0 3px;", "{margin:2px 2px;}.", "__multi-value{border:none;}", "__placeholder{color:#919499;}.", "__multi-value__label{padding:0 0 0 10px;color:#4d4d4d;}"], StyledMultiValue, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX);
var StyledOrderStatus = (0, _styledComponents["default"])(_OrderStatus["default"]).withConfig({
  displayName: "TicketFilterByOrderStatus__StyledOrderStatus",
  componentId: "sc-1uaaiiz-1"
})(["width:fit-content;display:flex;"]);
var StyledMultiValueRemove = (0, _styledComponents["default"])(StyledRemove).withConfig({
  displayName: "TicketFilterByOrderStatus__StyledMultiValueRemove",
  componentId: "sc-1uaaiiz-2"
})(["padding:0 0 0 5px !important;svg path{stroke:#17181a;}"]);
var TicketTypeMultiValueRemove = function TicketTypeMultiValueRemove(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledMultiValueRemove, props, /*#__PURE__*/_react["default"].createElement(_tagsSelect.Remove, null));
};
var options = Object.values(_constants.ORDER_STATUSES).map(function (status) {
  return {
    label: _constants.TITLES[status],
    status: status,
    value: status
  };
});
var TicketFilterByOrderStatus = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByOrderStatus(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByOrderStatus);
    _this = _callSuper(this, TicketFilterByOrderStatus, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByOrderStatus, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByOrderStatus, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var formatedValue = Array.isArray(value) ? value.map(function (v) {
        return v.status;
      }) : null;
      this.el.name = name;
      this.el.value = formatedValue;
      var event = new CustomEvent('change', {
        bubbles: true
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.el = _reactDom["default"].findDOMNode(ref);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        value = _this$props2.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var formatedValue = null;
      if (Array.isArray(value)) {
        formatedValue = value.map(function (v) {
          return {
            label: _constants.TITLES[v],
            status: v,
            value: v
          };
        });
      }
      return /*#__PURE__*/_react["default"].createElement(StyledTicketFilterByOrderStatus, (0, _extends2["default"])({}, props, {
        components: {
          MultiValue: TicketFilterByOrderStatus.renderMultiValue
        },
        isMulti: true,
        isSearchable: true,
        onChange: this.handleChange,
        options: options,
        placeholder: PLACEHOLDER,
        ref: this.handleRef,
        value: formatedValue
      }), function (_ref) {
        var data = _ref.data;
        var status = data.status;
        return /*#__PURE__*/_react["default"].createElement(StyledOrderStatus, {
          status: status
        });
      });
    }
  }], [{
    key: "renderMultiValue",
    value: function renderMultiValue(_ref2) {
      var data = _ref2.data,
        innerProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
      var status = data.status;
      return /*#__PURE__*/_react["default"].createElement("div", innerProps, /*#__PURE__*/_react["default"].createElement(StyledOrderStatus, {
        status: status,
        suffix: /*#__PURE__*/_react["default"].createElement(TicketTypeMultiValueRemove, innerProps.removeProps)
      }));
    }
  }]);
}(_react["default"].PureComponent);
TicketFilterByOrderStatus.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(Object.values(_constants.ORDER_STATUSES)).isRequired)
};
TicketFilterByOrderStatus.defaultProps = {
  className: '',
  name: '',
  onChange: Function.prototype,
  value: null
};
TicketFilterByOrderStatus.ORDER_STATUSES = _constants.ORDER_STATUSES;
var _default = exports["default"] = TicketFilterByOrderStatus;